import {
  useCallback
} from "react"
import classes from "./itemList.module.css"

const ItemList = (props) => {
  const {
    items, onItemClick, loading 
  } = props

  const onClick = useCallback(
    (item) => {
      onItemClick(item)
    },
    [onItemClick]
  )

  if (!loading && items.length === 0) {
    return <p className={classes.noItems}>No items find</p>
  }

  return (
    <div className={classes.root}>
      {items?.map((item) => (
        <div
          className={classes.item}
          key={item.id}
          onClick={() => {
            onClick(item)
          }}
        >
          <img
            loading='lazy'
            className={classes.img}
            src={item.pic}
            alt={item.alt || undefined }
          />
        </div>
      ))}
    </div>
  )
}

export default ItemList
